/**
 * AIストラテジー - インデックス
 *
 * 難易度に応じたストラテジーを取得する
 */

import { baseStrategy, randomPick, shuffleArray, type AIStrategy, type AIGameState, type UsableSkill, type ChargeableMonster } from './base';
import { easyStrategy } from './easy';
import { normalStrategy } from './normal';
import { hardStrategy } from './hard';
import { geneticStrategy, createGeneticStrategy } from './genetic';
import {
  simulationStrategy,
  createSimulationStrategy,
  createCustomSimulationStrategy,
  createGeneticSimulationStrategy,
  convertToGameState,
} from './simulation';
import { EVOLVED_GENOME } from '../genetic';

// Re-export types
export type { AIStrategy, AIGameState, UsableSkill, ChargeableMonster };

/** 難易度タイプ */
export type AIDifficulty = 'easy' | 'normal' | 'hard' | 'evolved' | 'evolvedSim';

/** 進化型AI（GA訓練済み閾値ベース）- 約10%勝率優位 */
const evolvedStrategy: AIStrategy = createGeneticStrategy(EVOLVED_GENOME);

/** 進化型AI シミュレーション版（GA訓練済み + シミュレーション評価）- 訓練中 */
const evolvedSimStrategy: AIStrategy = createGeneticSimulationStrategy(EVOLVED_GENOME);

const difficultyStrategies: Record<AIDifficulty, AIStrategy> = {
  easy: easyStrategy,
  normal: normalStrategy,
  hard: hardStrategy,
  evolved: evolvedStrategy,
  evolvedSim: evolvedSimStrategy,
};

/** 難易度からストラテジーを取得 */
export function getStrategy(difficulty: AIDifficulty, deckStrategyId: string | null = null): AIStrategy {
  const difficultyStrategy = difficultyStrategies[difficulty] || baseStrategy;

  // 将来拡張: デッキ専用ストラテジー
  // if (deckStrategyId) {
  //   const deckStrategy = getDeckStrategy(deckStrategyId);
  //   return mergeStrategies(difficultyStrategy, deckStrategy);
  // }

  return difficultyStrategy;
}

/**
 * ストラテジーをマージ（将来拡張用）
 * デッキ専用ストラテジーがnullを返した場合は難易度ストラテジーを使用
 */
// function mergeStrategies(baseStrat, deckStrat) {
//   const merged = {};
//   for (const key of Object.keys(baseStrategy)) {
//     merged[key] = (...args) => {
//       if (deckStrat[key]) {
//         const result = deckStrat[key](...args);
//         if (result !== null && result !== undefined) return result;
//       }
//       return baseStrat[key](...args);
//     };
//   }
//   return merged;
// }

export {
  baseStrategy,
  easyStrategy,
  normalStrategy,
  hardStrategy,
  evolvedStrategy,
  evolvedSimStrategy,
  geneticStrategy,
  createGeneticStrategy,
  simulationStrategy,
  createSimulationStrategy,
  createCustomSimulationStrategy,
  createGeneticSimulationStrategy,
  convertToGameState,
  randomPick,
  shuffleArray,
};
